import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApprovalMailModel, ClientApproveModel, ClientPortalStatusModel, compArchiveModel, ComponentModel, EngLetterStatusInputs, GenericResModel, HeaderResponseModel, ImageMLModel, ManagementLetter, ML, RearrangeNumbersModel, ReShareToClientModel, SendPackagerEmailModel, ShareToClientModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { addsectionReqModel, deleteSectionReqModel, reorderDataModel } from '../model/eng/add-section.model';
import { CommentStatusModel } from '../model/eng/comment-status.model';
import { EngSaveModel } from '../model/eng/eng-save.model';
import { IntegrationSourceInterface } from '../model/eng/integration-source.interface';
import { UndoDeletedCommentModel } from '../model/eng/undo-deleted-comment.model';
import { UndoDeletedIssueModel } from '../model/eng/undo-deleted-issue.model';
import { DraggedFileResponseModel } from '../model/file/drag/dragged-file.model';
import { EncodingService } from './encoding.service';

const textResponse: any = {responseType: 'text'};

@Injectable({
  providedIn: 'root'
})
export class EngApiService {

  private static readonly engBaseUri = environment.apiV1 + '/eng';
  private static readonly SEND_EMAIL = environment.apiV1 + '/sign-letter-mail';
  private static readonly SEND_PACKAGER_EMAIL = environment.apiV1 + '/mail/assign-packager';
  private static readonly MAP_CHECKLISTS = environment.apiV1 + '/map-checklists';
  private static readonly ADD_SECTION: string = environment.apiV1 + '/engagement-section';
  private static readonly REORDER_SECTIONS = environment.apiV1 + '/reorder-section';
  private static readonly GET_ELEMENTS = environment.apiV1 + '/elements';
  private static readonly ADD_ML = environment.apiV1 + '/management-letter/add';
  private static readonly GET_ML_DATA = environment.apiV1 + '/management-letter/get';
  private static readonly SHARE_ML_TO_CLIENT = environment.apiV1 + '/management-letter/share';
  private static readonly RE_SHARE_ML_TO_CLIENT = environment.apiV1 + '/management-letter/re-share';
  private static readonly UN_SHARE_ML_TO_CLIENT = environment.apiV1 + '/management-letter/un-share';
  private static readonly REVIEW_ML_BY_CLIENT = environment.apiV1 + '/management-letter/client/review';
  private static readonly GET_CLIENT_HEADER = environment.apiV1 + '/management-letter/client/header/get';
  private static readonly SAVE_CLIENT_HEADER = environment.apiV1 + '/management-letter/client/header/save';
  private static readonly GET_CLIENT_FOOTER = environment.apiV1 + '/management-letter/client/footer/get';
  private static readonly SAVE_CLIENT_FOOTER = environment.apiV1 + '/management-letter/client/footer/save';
  private static readonly SAVE_CLIENT_SIGNATURE = environment.apiV1 + '/management-letter/client/signature/save';
  private static readonly GET_CLIENT_SIGNATURE = environment.apiV1 + '/management-letter/client/signature/get';
  private static readonly GET_CLIENT_COMPONENT = environment.apiV1 + '/management-letter/client/components';
  private static readonly REMOVE_CLIENT_SIGNATURE = environment.apiV1 + '/management-letter/client/signature/remove';
  private static readonly SAVE_CLIENT_COMPONENT = environment.apiV1 + '/management-letter/client/component/save';
  private static readonly GET_CLIENT_HEADER_FOOTER = environment.apiV1 + '/management-letter/client/header-footer/get';
  private static readonly SEND_ML_MAIL = environment.apiV1 + '/management-letter/email';
  private static readonly DELETE_ML = '/management-letter/delete';
  private static readonly GET_ENG_LETTER_SIGN_STATUS = environment.apiV1 + '/engagement-letter-status';
  private static readonly COMPLETION_ARCHIVE = environment.apiV1 + '/completion-archive';
  private static readonly FINAL_REVIEW_BENCHMARK = environment.apiV1 + '/final-review-benchmark';
  private static readonly EXPORT_ENGAGEMENT_LIST = environment.apiV1 + '/eng/export';
  private static readonly RF_TEMPLATE_NAME_STATUS = environment.apiV1 + '/template/rf/exist';
  private static readonly ENG_SETTING = environment.apiV1 + '/setting';
  private static readonly NOTES = environment.apiV1 + '/note';
  private static readonly TICK_MARK = environment.apiV1 + '/tick-mark';
  private static readonly GET_ASSIGN_TEAM_OLD = environment.apiV1 + '/assign-team-old';
  private static readonly GET_EXISTING_DOC_REF = environment.apiV1 + '/all-existing-doc-ref';
  private static readonly SAVE_ENG_MULTIPLE_DOCS = environment.apiV1 + '/multiple-doc';
  private static readonly GET_WFS_BALANCE_SHEET = environment.apiV1 + '/wfs-balance-sheet';
  private static readonly GET_WFS_INCOME_STATEMENT = environment.apiV1 + '/wfs-income-statement';
  private static readonly GET_STATEMENT_OF_PARTNERS_CAPITAL = environment.apiV1 + '/statement-of-partners-capital';
  private static readonly SAVE_PARTNERS_CAPITAL_HORIZONTAL = environment.apiV1 + '/partners-capital-horizontal';
  private static readonly SAVE_BS_IS_LEAD_SHEET_GROUPING = environment.apiV1 + '/bs-is-lead-sheet-grouping';
  private static readonly REMOVE_ENG_LEFT_SIDE_DOC = environment.apiV1 + '/left-side-doc';
  private static readonly SAVE_CHECK_LIST_TEMPLATE_TO_ENG = environment.apiV1 + '/check-list-template-to-eng';
  private static readonly REPLACE_TEMPLATE_FOR_ENG = environment.apiV1 + '/replace-template-for-eng';
  private static readonly SAVE_ENG_DOC_LEFT_RIGHT_MIDDLE = environment.apiV1 + '/doc-left-right-middle';
  private static readonly SAVE_LEFT_SIDE_MULTIPLE_DOCS = environment.apiV1 + '/left-side-multiple-docs';
  private static readonly REPLACE_DOC_NAME = environment.apiV1 + '/replace-doc-name';
  private static readonly ENG_ISSUE = environment.apiV1 + '/eng-issue';
  private static readonly SAVE_ISSUE_STATUS = environment.apiV1 + '/issue-status';
  private static readonly SAVE_ISSUE_RESPONSE = environment.apiV1 + '/issue-response';
  private static readonly MOVE_ENG_LEF_SIDE_DOCS = environment.apiV1 + '/move-eng-left-side-doc';
  private static readonly SAVE_MASTER_SIGN_OFF = environment.apiV1 + '/master-sign-off';
  private static readonly SAVE_ENG_PLANNING_TEMPLATE = environment.apiV1 + '/planning-template';
  private static readonly SAVE_ENG_DOC_FOLDER = environment.apiV1 + '/doc-folder';
  private static readonly GET_LEFT_SIDE_CHILD_LEAD_SHEET_NAME = environment.apiV1 + '/left-side-child-lead-sheet-name';
  private static readonly SAVE_ENG_COMMENT_STATUS = environment.apiV1 + '/comment-status';
  private static readonly ENG_COMMENT = environment.apiV1 + '/eng/comment';
  private static readonly ENG_ALL_COMMENT = environment.apiV1 + '/eng/all-comment';
  private static readonly REMOVE_COMMENT_FROM_SECTION = environment.apiV1 + '/comment-from-section';
  private static readonly REMOVE_ISSUE_FROM_SECTION = environment.apiV1 + '/issue-from-section';
  private static readonly REMOVE_COMMENT_REFERENCE = environment.apiV1 + '/comment-reference';
  private static readonly SAVE_COMMENT_RESPONSE = environment.apiV1 + '/comment-response';
  private static readonly UNDO_DELETED_ENG_COMMENT = environment.apiV1 + '/undo-deleted-comment';
  private static readonly UNDO_DELETED_ENG_ISSUE = environment.apiV1 + '/undo-deleted-issue';
  private static readonly REMOVE_ISSUE_REFERENCE = environment.apiV1 + '/issue-reference';
  private static readonly ENG_ALL_ISSUE = environment.apiV1 + '/all-issue';
  private static readonly REMOVE_CHECK_LIST = environment.apiV1 + '/check-list';
  private static readonly SAVE_ENG_LETTER_SIGN_STATUS = environment.apiV1 + '/letter-sign-status';
  private static readonly LOAD_RFT_WORKBOOK_SRC_TRG = environment.apiV1 + '/load-rft-workbook-src-trg';
  private static readonly LEAD_SHEET_AMOUNT = environment.apiV1 + '/lead-sheet-amount';
  private static readonly SAVE_ENG_DOC_MIDDLE_REF = environment.apiV1 + '/doc-middle-ref';
  private static readonly GET_MATERIALITY_DATA = environment.apiV1 + '/materiality-data';
  private static readonly SAVE_MATERIALITY_PERIOD = environment.apiV1 + '/materiality-period';
  private static readonly SAVE_COMPLETION_NTR_INFO = environment.apiV1 + '/completion-ntr-info';
  private static readonly GET_COMPLETION_ENG_CLIENT_APPROVAL = environment.apiV1 + '/completion-client-approval';
  private static readonly SAVE_NTR_CLIENT_APPROVAL_SIGN_OFF = environment.apiV1 + '/ntr-client-approval-sign-off';
  private static readonly SAVE_COMPLETION_DONE = environment.apiV1 + '/completion-done';
  private static readonly SAVE_COMPLETION_QUESTION_RESPONSE = environment.apiV1 + '/completion-question-response';
  private static readonly GET_COMPLETION_TAX_RETURN = environment.apiV1 + '/completion-tax-return';
  private static readonly SAVE_TAX_RETURN_RESPONSE = environment.apiV1 + '/tax-return-response';
  private static readonly SAVE_TAX_RETURN = environment.apiV1 + '/tax-return';
  private static readonly COMPLETION_INSTRUCTION = environment.apiV1 + '/completion-instruction';
  private static readonly COMPLETION_COVER_LETTER = environment.apiV1 + '/completion-cover-letter';
  private static readonly COMPLETION_NTR_PACKAGE = environment.apiV1 + '/completion-ntr-package';
  private static readonly GET_COMPLETION_TAX_DOC = environment.apiV1 + '/completion-tax-doc';
  private static readonly GET_VIEW_ALL_ADJ_ENTRIES = environment.apiV1 + '/view-all-adj-entry';
  private static readonly SAVE_CLOSE_AND_REOPEN = environment.apiV1 + '/close-and-reopen';
  private static readonly SAVE_COMPLETION_ARCHIVE_ENG = environment.apiV1 + '/completion-archive-ang';
  private static readonly SAVE_COMPLETION_COMPLETE_ENG = environment.apiV1 + '/completion-complete-eng';
  private static readonly GET_BS_IS_ACC_NAME = environment.apiV1 + '/bs-is-acc-names';
  private static readonly SAVE_ROUNDING = environment.apiV1 + '/rounding';
  private static readonly GET_INCOME_STATEMENT = environment.apiV1 + '/income-statement';
  private static readonly GET_TABLE_OF_CONTENT = environment.apiV1 + '/table-of-content';
  private static readonly GET_TB_DAILY_LOAD_FROM_UI = environment.apiV1 + '/tb-daily-load-from-ui';

  public readonly elementSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public readonly elements$: Observable<any> = this.elementSubject.asObservable();
  private readonly ALL_ADJUSTMENT_ENTRIES = '/adjustment-entries';

  constructor(private httpClient: HttpClient, private encodingService: EncodingService, private toaster: ToastrService) {
  }

  public async fetchIntegrationSource(engagementId: number): Promise<IntegrationSourceInterface> {
    return await this.httpClient
      .post<IntegrationSourceInterface>(EngApiService.engBaseUri + '/integration-source', engagementId, {responseType: 'json'})
      .toPromise();
  }

  public saveEngagement(data: EngSaveModel): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(environment.apiV1 + '/eng', data);
  }

  public getEngagementsDetail(engId: number): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(environment.apiV1 + `/engagement-detail/${engId}`).pipe(
      map(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          res.errors.forEach(e => this.toaster.error(e));
          return null;
        }
      }));
  }

  public addTemplateToEngagement(data): Observable<any> {
    const path = environment.apiV1 + '/eng-template';
    return this.httpClient.post(path, this.encodingService.enData(data), textResponse);
  }

  public sendMailNotifications(data): Observable<any> {
    return this.httpClient.post(EngApiService.SEND_EMAIL, data, textResponse);
  }

  public sendAssignedPackagerEmail(data): Observable<GenericResModel<SendPackagerEmailModel>> {
    return this.httpClient.post<GenericResModel<SendPackagerEmailModel>>(EngApiService.SEND_PACKAGER_EMAIL, data, {responseType: 'json'});
  }

  public mapChecklists(data): Observable<any> {
    return this.httpClient.post(EngApiService.MAP_CHECKLISTS, data, textResponse);
  }

  public addSectionToEngagment(data: addsectionReqModel): Observable<any> {
    return this.httpClient.post(EngApiService.ADD_SECTION, data, textResponse);
  }

  public deleteSectionFromEngagement(data: deleteSectionReqModel): Observable<any> {
    return this.httpClient.delete(EngApiService.ADD_SECTION, {body: data});
  }

  public getAutomatedElements(data: any) {
    if (this.elementSubject.getValue()) {
      return this.elements$;
    }
    return this.httpClient.post(EngApiService.GET_ELEMENTS, this.encodingService.enData(data), textResponse).pipe(
      tap(res => this.elementSubject.next(res))
    );
  }

  public addManagementLetter(data: any): Observable<any> {
    return this.httpClient.post(EngApiService.ADD_ML, data, textResponse);
  }

  public getMLData(id: number, clientFirmId: number = 0): Observable<ManagementLetter> {
    return this.httpClient.post<ManagementLetter>(EngApiService.GET_ML_DATA, {
      'engagementId': id,
      'clientFirmId': clientFirmId
    });
  }

  public shareToClient(Obj: ShareToClientModel): Observable<any> {
    return this.httpClient.post(EngApiService.SHARE_ML_TO_CLIENT, Obj);
  }

  public reShareToClient(Obj: ReShareToClientModel): Observable<any> {
    return this.httpClient.post(EngApiService.RE_SHARE_ML_TO_CLIENT, Obj);
  }

  public saveClientHeader(Obj: ImageMLModel): Observable<any> {
    return this.httpClient.post(EngApiService.SAVE_CLIENT_HEADER, Obj, textResponse);
  }

  public getClientHeader(firmUserAcctId: number, clientFirmId: number): Observable<HeaderResponseModel> {
    return this.httpClient.post<HeaderResponseModel>(EngApiService.GET_CLIENT_HEADER, {
      'firmUserAcctId': firmUserAcctId,
      'clientFirmId': clientFirmId
    });
  }

  public saveClientFooter(Obj: ImageMLModel): Observable<any> {
    return this.httpClient.post(EngApiService.SAVE_CLIENT_FOOTER, Obj, textResponse);
  }

  public saveClientComponent(Obj: ImageMLModel): Observable<any> {
    return this.httpClient.post(EngApiService.SAVE_CLIENT_COMPONENT, Obj, textResponse);
  }

  public getClientFooter(firmUserAcctId: number, clientFirmId: number): Observable<any> {
    return this.httpClient.post(EngApiService.GET_CLIENT_FOOTER, {
      'firmUserAcctId': firmUserAcctId,
      'clientFirmId': clientFirmId
    });
  }

  public getClientMLSignature(engagementId: number, clientFirmId: number): Observable<any> {
    return this.httpClient.post(EngApiService.GET_CLIENT_SIGNATURE, {
      'clientFirmId': clientFirmId,
      'engagementId': engagementId
    });
  }

  public saveClientMLSignature(Obj: ImageMLModel): Observable<any> {
    return this.httpClient.post(EngApiService.SAVE_CLIENT_SIGNATURE, Obj, textResponse);
  }

  public saveClientApproval(Obj: ClientApproveModel): Observable<any> {
    return this.httpClient.post(EngApiService.REVIEW_ML_BY_CLIENT, Obj, textResponse);
  }

  /**
   * gets header,footer,signature for an Management Letter
   * @param firmUserAcctId
   * @param clientFirmId
   *
   */

  public getClientComponents(firmUserAcctId: number, clientFirmId: number): Observable<any> {
    return this.httpClient.post(EngApiService.GET_CLIENT_COMPONENT, {
      'firmUserAcctId': firmUserAcctId,
      'clientFirmId': clientFirmId
    });
  }

  public removeClientSignature(clientFirmId: number, subModuleId: number): Observable<any> {
    return this.httpClient.post(EngApiService.REMOVE_CLIENT_SIGNATURE, {
      'clientFirmId': clientFirmId,
      'subModuleId': subModuleId
    });
  }

  public unShareManagementLetter(Obj: ML): Observable<any> {
    return this.httpClient.post(EngApiService.UN_SHARE_ML_TO_CLIENT, Obj, textResponse);
  }

  public getClientHeaderFooter(id: number, clientFirmId: number): Observable<ComponentModel> {
    return this.httpClient.post<ComponentModel>(EngApiService.GET_CLIENT_HEADER_FOOTER, {
      'engagementId': id,
      'clientFirmId': clientFirmId
    });
  }

  public sendMailForApproval(Obj: ApprovalMailModel): Observable<any> {
    return this.httpClient.post(EngApiService.SEND_ML_MAIL, Obj);
  }

  public deleteManagementLetter(id: number): Observable<any> {
    const path = environment.apiV1 + '/' + id + EngApiService.DELETE_ML;
    return this.httpClient.delete(path);
  }

  public fetchClientPortalStatus(clientFirmId: number): Observable<ClientPortalStatusModel> {
    const path = environment.apiV1 + '/' + encodeURIComponent(this.encodingService.enData(clientFirmId)) + '/client-status';
    return this.httpClient.get<ClientPortalStatusModel>(path);
  }

  public deleteEngagement(id: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(environment.apiV1 + '/engagement', {
      body: id
    });
  }

  public renameSectionName(data: addsectionReqModel): Observable<any> {
    return this.httpClient.put<GenericResModel<any>>(EngApiService.ADD_SECTION, data, textResponse);
  }

  public reorderSections(data: reorderDataModel): Observable<any> {
    return this.httpClient.put<GenericResModel<any>>(EngApiService.REORDER_SECTIONS, data, textResponse);
  }

  public getEngLetterSignStatus(Obj: EngLetterStatusInputs): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.GET_ENG_LETTER_SIGN_STATUS, Obj);
  }

  public getCompletionArchive(engagmentid): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(EngApiService.COMPLETION_ARCHIVE + '?engagementId=' + engagmentid);
  }

  public saveCompleitonArchive(data: compArchiveModel): Observable<any> {
    return this.httpClient.put<GenericResModel<any>>(EngApiService.COMPLETION_ARCHIVE, data);
  }

  public getBenchMarkDetails(engagmentid): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(EngApiService.FINAL_REVIEW_BENCHMARK + '?engagementId=' + engagmentid);
  }

  public rearrangeNumbers(data: RearrangeNumbersModel[]): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(environment.apiV1 + '/rearrange-document-numbers', {'rearrangeDocuments': data});
  }

  public exportEngagementList(data): Observable<any> {
    return this.httpClient.post<GenericResModel<any>>(EngApiService.EXPORT_ENGAGEMENT_LIST, {'engagementsId': data});
  }

  public getEngLeftSectionDocs(engId: string, acctYear: number): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/eng-left-section-docs',
      {params: {engId: engId, acctYear: acctYear}});
  }

  public getClientOnboarding(engId: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/client-onboarding', {params: {engId: engId}});
  }

  public getEngagementUSer(engId: number): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/eng/user', {params: {engId: engId}});
  }

  public getEngDocRequestResponse(engId: string, subModuleId: number, parentSubModuleId: number, type: string, searchText: string, data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/eng/doc-request-response',
      {
        params: {
          engId: engId,
          subModuleId: subModuleId,
          parentSubModuleId: parentSubModuleId,
          type: type,
          searchText: searchText,
          inList: data
        }
      });
  }

  public getEngagementIssue(engId: string, subModuleId: string, refPkeyId: number, searchText: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.ENG_ISSUE,
      {params: {engId: engId, subModuleId: subModuleId, refPkeyId: refPkeyId, searchText: searchText}});
  }

  public getCompletionEngLetter(engId: number): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(environment.apiV1 + '/completion-eng-letter', {params: {engId: engId}});
  }

  public getCompletionEngQuestion(engId: number, completionType: string): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(environment.apiV1 + '/completion-eng-question',
      {params: {engId: engId, completionType: completionType}});
  }

  public getCompletionEngStatus(engId: number): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(environment.apiV1 + '/completion-status', {params: {engId: engId}});
  }

  public getEngParentFolderName(newReq: number): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/parent-folder-name', {params: {newRequest: newReq}});
  }

  public getEngComment(engId: number, subModuleId: number, searchText: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.ENG_COMMENT,
      {params: {engId: engId, subModuleId: subModuleId, searchText: searchText}});
  }

  public getAssignTeam(): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/assignable-team');
  }

  public getLeftFinancialStatement(engId: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/left-financial-statement', {params: {engId: engId}});
  }

  public getEngDocumentFolderFile(engId: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/eng-doc-folder-file', {params: {engId: engId}});
  }

  public getLeftSideFolders(engId: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/left-side-folder', {params: {engId: engId}});
  }

  public getEngForNotification(engId: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/eng-for-notification', {params: {engId: engId}});
  }

  public getQuestionAnswer(subModuleId: number, engId: number, checklistStandardId: number | string): Observable<string> {
    const data = {
      subModuleId: subModuleId,
      engId: engId
    };
    if (checklistStandardId && checklistStandardId !== 'null') {
      data[checklistStandardId] = checklistStandardId;
    }
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/eng/question-answer', {params: data}).pipe(
      map(res => {
        if (res?.status !== 200) {
          res.errors.forEach(err => {
            this.toaster.error(err);
          });
        }
        return res?.data;
      }));
  }

  public loadClientOnBoarding(engId: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.get<GenericResModel<boolean>>(environment.apiV1 + '/load-client-onboarding', {params: {engId: engId}});
  }

  public loadCsvTrialBalanceSrcTrg(engId: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.get<GenericResModel<boolean>>(environment.apiV1 + '/load-csv-trial-balance-src-trg', {params: {engId: engId}});
  }

  public getFinancialStatement(clientFirmId: number): Observable<any> {
    return this.httpClient.get(environment.apiV1 + '/financial-statement', {params: {clientFirmId: clientFirmId}});
  }

  public getNewAuditRole(): Observable<any> {
    return this.httpClient.get(environment.apiV1 + '/new-audit-role');
  }

  public getRfEngTemplate(clientFirmId: number): Observable<any> {
    return this.httpClient.get(environment.apiV1 + '/rf-eng-template', {params: {clientFirmId: clientFirmId}});
  }

  public getEngagementType(): Observable<any> {
    return this.httpClient.get(environment.apiV1 + '/eng-type');
  }

  public getEngagementPeriod(): Observable<any> {
    return this.httpClient.get(environment.apiV1 + '/eng-period');
  }

  public getRfTemplateNameStatus(data): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<any>>(EngApiService.RF_TEMPLATE_NAME_STATUS, data);
  }

  public getRfTemplateEng(rfTemplateId: number): Observable<any> {
    return this.httpClient.get(environment.apiV1 + '/rf-template-eng', {params: {rfTemplateId: rfTemplateId}});
  }

  public saveEngComment(comment: any): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.ENG_COMMENT, comment);
  }

  public getProcedureLeftSectionDocs(engId: number = null): Observable<string> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/proc-left-section-docs', {params: {engId: engId}})
      .pipe(map(res => {
        if (res.status !== 200 && res.status !== 204) {
          res.errors.forEach(err => this.toaster.warning(err));
        }
        return res.data;
      }));
  }

  public getProRightSectionDocs(engId: number): Observable<string> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/pro-right-section-docs', {params: {engId: engId}})
      .pipe(map(res => {
        if (res.status !== 200 && res.status !== 204) {
          res.errors.forEach(err => this.toaster.warning(err));
        }
        return res.data;
      }));
  }

  public getCheckListRefDoc(engId: string, clientQuestionId: number): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/checklist-ref', {
      params: {
        engId: engId,
        clientQuestionId: clientQuestionId
      }
    })
  }

  public saveCheckListRef(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(environment.apiV1 + '/checklist-ref', data);
  }

  public getPartnershipAccount(engId: string): Observable<string> {
    return this.httpClient.get<GenericResModel<string>>(environment.apiV1 + '/partnership-account', {params: {engId: engId}})
      .pipe(map(res => {
        if (res.status !== 200 && res.status !== 204) {
          res.errors.forEach(err => this.toaster.warning(err));
        }
        return res.data;
      }));
  }

  public getEngSetting(engId: string): Observable<string> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.ENG_SETTING, {params: {engId: engId}})
      .pipe(map(res => {
        if (res.status !== 200 && res.status !== 204) {
          res.errors.forEach(err => this.toaster.warning(err));
        }
        return res.data;
      }));
  }

  public getEngNote(engId, refPkeyId): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.NOTES, {
      params: {
        engId: engId,
        refPkeyId: refPkeyId
      }
    });
  }

  public saveEngNote(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.NOTES, data);
  }

  public getTickMark(searchTxt): Observable<string> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.TICK_MARK, {params: {searchTxt: searchTxt}})
      .pipe(map(res => {
        if (res.status !== 200 && res.status !== 204) {
          res.errors.forEach(err => this.toaster.warning(err));
        }
        return res.data;
      }));
  }

  public saveTickMark(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.TICK_MARK, data);
  }

  public getAssignTeamOld(): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_ASSIGN_TEAM_OLD);
  }

  public getAllExistingDocReference(engId, subModuleId, engTeamClientDocId, engLeftSideDocId): Observable<GenericResModel<string>> {
    const params = {};
    if (engId && engId !== 'null') {
      params[engId] = engId;
    }
    if (subModuleId && subModuleId !== 'null') {
      params[subModuleId] = subModuleId;
    }
    params[engTeamClientDocId] = engTeamClientDocId;
    params[engLeftSideDocId] = engLeftSideDocId;

    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_EXISTING_DOC_REF, {params: params});
  }

  public saveEngMultipleDocuments(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.SAVE_ENG_MULTIPLE_DOCS, data);
  }

  public getWFSBalanceSheet(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_WFS_BALANCE_SHEET, {params: {data: data}});
  }

  public getWFSIncomeStatement(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_WFS_INCOME_STATEMENT, {params: {data: data}});
  }

  public getStatementOfPartnersCapital(engId: number, dataType: number): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_STATEMENT_OF_PARTNERS_CAPITAL,
      {params: {engId: engId, dataType: dataType}});
  }

  public savePartnerCapitalHorizontal(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_PARTNERS_CAPITAL_HORIZONTAL, data);
  }

  public saveBsIsLeadSheetGrouping(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_BS_IS_LEAD_SHEET_GROUPING, data);
  }

  public deleteEngLeftSideDoc(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.REMOVE_ENG_LEFT_SIDE_DOC, {params: {data: data}});
  }

  public saveCheckListTemplateToEng(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_CHECK_LIST_TEMPLATE_TO_ENG, data);
  }

  public replaceTemplateForEng(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.put<GenericResModel<boolean>>(EngApiService.REPLACE_TEMPLATE_FOR_ENG, data);
  }

  public saveEngDocLeftRightMiddle(data: string): Observable<DraggedFileResponseModel | null> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.SAVE_ENG_DOC_LEFT_RIGHT_MIDDLE, data).pipe(
      map(res => {
        if (res.status === 200 || res.status === 204) {
          return JSON.parse(res.data);
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }

  public saveLeftSideMultipleDocs(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.SAVE_LEFT_SIDE_MULTIPLE_DOCS, data);
  }

  public replaceDocName(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.put<GenericResModel<string>>(EngApiService.REPLACE_DOC_NAME, data);
  }

  public saveEngIssue(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.ENG_ISSUE, data);
  }

  public saveEngIssueStatus(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_ISSUE_STATUS, data);
  }

  public saveEngIssueResponse(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.SAVE_ISSUE_RESPONSE, data);
  }

  public moveEngLeftSideDocs(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.put<GenericResModel<boolean>>(EngApiService.MOVE_ENG_LEF_SIDE_DOCS, data);
  }

  public saveMasterSignOff(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_MASTER_SIGN_OFF, data);
  }

  public saveEngPlanningTemplate(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_ENG_PLANNING_TEMPLATE, data);
  }

  public saveEngDocFolder(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_ENG_DOC_FOLDER, data);
  }

  public getLeftSideChildLeadSheetName(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_LEFT_SIDE_CHILD_LEAD_SHEET_NAME, {params: {data: data}});
  }

  public saveEngCommentStatus(commentStatusModel: CommentStatusModel): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_ENG_COMMENT_STATUS, commentStatusModel);
  }

  public deleteComment(commentId: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.ENG_COMMENT, {params: {commentId: commentId}});
  }

  public deleteAllComment(engId: number, isAllComments: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.ENG_ALL_COMMENT,
      {params: {engId: engId, isAllComments: isAllComments}});
  }

  public removeCommentFromSection(subModuleId: number, isAllComment: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.REMOVE_COMMENT_FROM_SECTION,
      {params: {subModuleId: subModuleId, isAllComment: isAllComment}});
  }

  public deleteCommentReference(engCommentResponseId: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.REMOVE_COMMENT_REFERENCE,
      {params: {engCommentResponseId: engCommentResponseId}});
  }

  public saveEngCommentResponse(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_COMMENT_RESPONSE, data);
  }

  public deleteIssue(issueId: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.ENG_ISSUE, {params: {issueId: issueId}});
  }

  public undoDeletedEngIssue(undoDeletedIssue: UndoDeletedIssueModel): Observable<GenericResModel<boolean>> {
    return this.httpClient.put<GenericResModel<boolean>>(EngApiService.UNDO_DELETED_ENG_ISSUE, undoDeletedIssue);
  }

  public undoDeletedEngComment(undoDeletedComment: UndoDeletedCommentModel): Observable<GenericResModel<boolean>> {
    return this.httpClient.put<GenericResModel<boolean>>(EngApiService.UNDO_DELETED_ENG_COMMENT, undoDeletedComment);
  }

  public removeIssueFromSection(subModuleId: number, isAllIssue: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.REMOVE_ISSUE_FROM_SECTION,
      {params: {subModuleId: subModuleId, isAllIssue: isAllIssue}});
  }

  public deleteAllIssue(engId: number, isAllIssue: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.ENG_ALL_ISSUE,
      {params: {engId: engId, isAllIssue: isAllIssue}});
  }

  public deleteIssueReference(engIssueResponseId: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.REMOVE_ISSUE_REFERENCE,
      {params: {engIssueResponseId: engIssueResponseId}});
  }

  public deleteCheckList(engId: number, subModuleId: number): Observable<GenericResModel<boolean>> {
    return this.httpClient.delete<GenericResModel<boolean>>(EngApiService.REMOVE_CHECK_LIST,
      {params: {engId: engId, subModuleId: subModuleId}});
  }

  public saveEngLetterSignStatus(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_ENG_LETTER_SIGN_STATUS, data);
  }

  public loadRFTWorkBookSrcTrg(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.LOAD_RFT_WORKBOOK_SRC_TRG, data);
  }

  public getLeadSheetAmount(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.LEAD_SHEET_AMOUNT, {params: {data: data}});
  }

  public saveEngDocMiddleRef(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.SAVE_ENG_DOC_MIDDLE_REF, data);
  }

  public updateLeadSheetAmount(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.put<GenericResModel<boolean>>(EngApiService.LEAD_SHEET_AMOUNT, data);
  }

  public getMaterialityData(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_MATERIALITY_DATA, {params: {data: data}});
  }

  public saveEngMaterialityPeriod(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_MATERIALITY_PERIOD, data);
  }

  public saveCompletionNtrInfo(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_COMPLETION_NTR_INFO, data);
  }

  public getCompletionEngClientApproval(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_COMPLETION_ENG_CLIENT_APPROVAL, {params: {data: data}});
  }

  public saveNtrClientApprovalSignOff(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_NTR_CLIENT_APPROVAL_SIGN_OFF, data);
  }

  public saveCompletionDone(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_COMPLETION_DONE, data);
  }

  public saveCompletionQuestionResponse(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_COMPLETION_QUESTION_RESPONSE, data);
  }

  public getCompletionTaxReturn(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_COMPLETION_TAX_RETURN, {params: {data: data}});
  }

  public saveTaxReturnEngResponse(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_TAX_RETURN_RESPONSE, data);
  }

  public saveTaxReturn(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_TAX_RETURN, data);
  }

  public getCompletionInstruction(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.COMPLETION_INSTRUCTION, {params: {data: data}});
  }

  public saveCompletionInstruction(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.COMPLETION_INSTRUCTION, data);
  }

  public getCompletionCoverLetter(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.COMPLETION_COVER_LETTER, {params: {data: data}});
  }

  public saveCompletionCoverLetter(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.COMPLETION_INSTRUCTION, data);
  }

  public getCompletionNtrPackage(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.COMPLETION_NTR_PACKAGE, {params: {data: data}});
  }

  public saveCompletionNtrPackage(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.COMPLETION_NTR_PACKAGE, data);
  }

  public getCompletionTaxDoc(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_COMPLETION_TAX_DOC, {params: {data: data}});
  }

  public viewAllAdjEntries(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_VIEW_ALL_ADJ_ENTRIES, {params: {data: data}});
  }

  public saveCloseAndReopenEng(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.post<GenericResModel<string>>(EngApiService.SAVE_CLOSE_AND_REOPEN, data);
  }

  public saveCompletionArchiveEng(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_COMPLETION_ARCHIVE_ENG, data);
  }

  public saveCompletionCompleteEng(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_COMPLETION_COMPLETE_ENG, data);
  }

  public getBsIsAccNames(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_BS_IS_ACC_NAME, {params: {data: data}});
  }

  public saveRounding(data: string): Observable<GenericResModel<boolean>> {
    return this.httpClient.post<GenericResModel<boolean>>(EngApiService.SAVE_ROUNDING, data);
  }

  public updateEngSetting(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.put<GenericResModel<string>>(EngApiService.ENG_SETTING, data);
  }

  public getIncomeStatement(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_INCOME_STATEMENT, {params: {data: data}});
  }

  public getTableOfContent(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_TABLE_OF_CONTENT, {params: {data: data}});
  }

  public getTbDailyLoadFromUi(data: string): Observable<GenericResModel<string>> {
    return this.httpClient.get<GenericResModel<string>>(EngApiService.GET_TB_DAILY_LOAD_FROM_UI, {params: {data: data}});
  }

  public getAllAdjustmentEntries(engagmentid): Observable<any> {
    return this.httpClient.get<GenericResModel<any>>(environment.apiV1 + '/' + engagmentid + this.ALL_ADJUSTMENT_ENTRIES);
  }
}
